module.exports = __webpack_public_path__ + "media/navi/navi_ok-57dc785b.png";